// @ts-check

import React from 'react';
import { object } from 'prop-types';
import USER from 'containers/pages/profile/ts/profileEditorEnum';
import ProfilePaper from './ProfilePaper';
import Grid from '@mui/material/Grid';
import ProfileTextField from './ProfileTextField';
import Avatar from '@mui/material/Avatar';

/**
 * @component ProfileSummary
 * @param {Object} props
 * @param {ProfileUser} props.user
 * @param {UserInfoType} props.userInfo
 * @returns {JSX.Element}
 */
function ProfileSummary({ user, userInfo }) {
	return (
		<ProfilePaper>
			<Grid container spacing={2} justifyContent="space-between" alignItems="center">
				<Grid item lg={3.375 / 2} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
					<Avatar alt="User Image" src={userInfo.image} sx={{ width: '8rem', height: '8rem' }} />
				</Grid>
				<Grid item lg={3.375} xs={12}>
					<ProfileTextField label="First name" value={user[USER.FIRST_NAME]} />
				</Grid>
				<Grid item lg={3.375} xs={12}>
					<ProfileTextField label="Last name" value={user[USER.LAST_NAME]} />
				</Grid>
				<Grid item lg={3.375} xs={12}>
					<ProfileTextField label="Username" value={user[USER.USERNAME]} />
				</Grid>
			</Grid>
		</ProfilePaper>
	);
}

ProfileSummary.propTypes = { user: object, userInfo: object };

export default ProfileSummary;
